module.exports = __webpack_public_path__ + "fonts/DINRoundPro-Bold.woff?83a785cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINRoundPro-Bold.woff
// module id = 847
// module chunks = 0 1 2 3 4 5